import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.css";

// Import dashboard components
import UserDashboard from "./components/UserDashboard";
import AdminDashboard from "./components/AdminDashboard";
import AuthForms from "./components/AuthForms";

// Import auth utilities
import { isAuthenticated, isAdminAuthenticated } from "./utils/authUtils";

// Protected Route Component
const ProtectedRoute = ({ children, isAdmin = false }) => {
  const authenticated = isAdmin ? isAdminAuthenticated() : isAuthenticated();

  if (!authenticated) {
    return <Navigate to={isAdmin ? "/admin/login" : "/login"} replace />;
  }

  return children;
};

// Public Route Component (redirect if already logged in)
const PublicRoute = ({ children, isAdmin = false }) => {
  const authenticated = isAdmin ? isAdminAuthenticated() : isAuthenticated();

  if (authenticated) {
    return (
      <Navigate to={isAdmin ? "/admin/dashboard" : "/dashboard"} replace />
    );
  }

  return children;
};

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Default route - redirect to login */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* User Authentication Routes */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <AuthForms isAdmin={false} />
              </PublicRoute>
            }
          />

          {/* User Dashboard Route */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <UserDashboard />
              </ProtectedRoute>
            }
          />

          {/* Admin Authentication Routes */}
          <Route
            path="/admin/login"
            element={
              <PublicRoute isAdmin={true}>
                <AuthForms isAdmin={true} />
              </PublicRoute>
            }
          />

          {/* Admin Dashboard Route */}
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute isAdmin={true}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          {/* 404 Not Found - redirect to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
